import { ComponentThemeType } from './theme.types';

export const dialogsTheme: ComponentThemeType = {
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontWeight: 600,
        fontSize: 'Medium',
        padding: '10px 24px',
        '.MuiButtonBase-root.MuiIconButton-root': {
          top: '0px',
          right: '0px',
        },
      },
    },
  },
};
